import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../views/Login/Login";
import ForgotPassword from "../views/Login/ForgotPassword";
import ResetPassword from "../views/Login/ResetPassword";
import ChangePassword from "../views/Hospital-Admin/Settings/ChangePassword";
import Dashboard from "../views/Hospital-Admin/Dashboard/dashboard";
import Patients from "../views/Hospital-Admin/Patients/Patients";
import Billing from "../views/Hospital-Admin/Billing/Billing";
import OPD from "../views/Hospital-Admin/OPD/opd";
import Assessment from "../views/Hospital-Admin/OPD/Assessment";
import Pharmacy from "../views/Hospital-Admin/Pharmacy/Pharmacy";
import DoctorOPD from "../views/Doctor-Side/OPD/opd";
import DoctorAssessment from "../views/Doctor-Side/OPD/Assessment";
import OPDDetails from "../views/Doctor-Side/OPD/OPD-details";
import DoctorDiagnostics from "../views/Doctor-Side/Diagnostics/Diagnostics";
import CreateLabReports from "../views/Hospital-Admin/CreateLabReport/create-lab-report";
import PatientSelection from "../views/Hospital-Admin/CreateLabReport/patient-selection";
import ViewCreateLabRepor from "../views/Hospital-Admin/CreateLabReport/view-create-lab-report";
import Consents from "../views/Hospital-Admin/Consents/consents";
import Listing from "../views/Hospital-Admin/Listing/Listing";
import Layout from "../views/Layout/Layout";
import ProtectedRoute from "../components/common/ProtectedRoute";
import Unauthorized from "../views/common/Unauthorized";
import { PERMISSIONS } from "../types/auth";
import PrintInvoice from "../components/Invoice/PrintInvoice";
import BillingPrintInvoice from "../components/Invoice/BillingPrintInvoice";
import PatientsLists from "../views/Hospital-Admin/Patients/PatientsList";
import AssessmentPatientList from "../views/Hospital-Admin/OPD/AssessmentPatientList";
import DischargeSummary from "../views/Hospital-Admin/DischargeSummary/DischargeSummary";
import DischargeSummaryForm from "../views/Hospital-Admin/DischargeSummary/DischargeSummaryForm";
import HospitalDetails from "../../src/views/Hospital-Admin/HospitalDetails/Hospital-Details";
import PatientDetailNew from "../views/Hospital-Admin/Patients/PatientDetailNew";
import VisitSummary from "../views/Hospital-Admin/Patients/VisitSummary";

import Home from "../m1/views/page/Home";
import AbhaAbout from "../m1/views/Abha-home/UserFlow";
import UserProfileABDM from "../m1/views/ABDM-Profile/ABDM-profile";
import UserABHAcard from "../m1/views/ABDM-Profile/ABHA-Card";
import AadharVerificationPage from "../m1/views/Create-ABHA/AadharVerification";
import DeleteDeactivateAccount from "../m1/views/ABDM-Profile/Delete-Deactivate-account";
import LoginABHAPage from "../m1/views/Login-ABHA/Login-ABHA-page";
import ForgotABHAPage from "../m1/views/Forgot-ABHA/Forgot-ABHA";
import ReactivateABHA from "../m1/views/Reactivate-ABHA/Reactivate-ABHA";
import Partnerships from "../m1/views/page/Partnerships";
import Products from "../m1/views/page/Products";
import GetDemo from "../m1/views/page/GetDemo";
import Contact from "../m1/views/page/Contact";
import UserABHAprofile from "../m1/views/ABDM-Profile/Profile";
import FindAbha from "../m1/views/Find-ABHA/FindABHA";
import StringEncryption from "../m1/views/StringEncryption/StringEncryption";

// Layout wrapper component for authenticated routes with optional RBAC guards
const LayoutWrapper = ({
  children,
  permission,
  anyPermissions,
  allPermissions,
  role,
}) => {
  return (
    <ProtectedRoute
      permission={permission}
      anyPermissions={anyPermissions}
      allPermissions={allPermissions}
      role={role}
    >
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
};

const WebRoutes = () => {
  return (
    <>
      <Suspense>
        <Routes>
          {/* Public routes without layout */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected routes with layout & RBAC capabilities */}
          <Route
            path="/change-password"
            element={
              <LayoutWrapper>
                <ChangePassword />
              </LayoutWrapper>
            }
          />
          <Route
            path="/dashboard"
            element={
              <LayoutWrapper role={[1, 2, 3, 10, 11]}>
                <Dashboard />
              </LayoutWrapper>
            }
          />
          <Route
            path="/patients"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 4, 5, 8, 9, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.OPD_VIEW_QUEUE,
                  PERMISSIONS.PATIENTS_READ,
                ]}
              >
                <OPD />
              </LayoutWrapper>
            }
          />
          <Route
            path="/hospital-details"
            element={
              <LayoutWrapper role={[1, 2]} permission={PERMISSIONS.HOSPITAL_MANAGE}>
                <HospitalDetails />
              </LayoutWrapper>
            }
          />
          <Route
            path="/billing"
            element={
              <LayoutWrapper
                role={[1, 2, 8, 9, 11]}
                anyPermissions={[
                  PERMISSIONS.BILLING_READ,
                  PERMISSIONS.BILLING_READ_INVOICE,
                ]}
              >
                <Billing />
              </LayoutWrapper>
            }
          />
          <Route
            path="/select-patient-billing"
            element={
              <LayoutWrapper
                role={[1, 2, 8, 9, 11]}
                anyPermissions={[
                  PERMISSIONS.BILLING_READ,
                  PERMISSIONS.BILLING_READ_INVOICE,
                ]}
              >
                <Billing />
              </LayoutWrapper>
            }
          />
          <Route
            path="/pharmacy"
            element={
              <LayoutWrapper
                role={[1, 2, 7]}
                anyPermissions={[
                  PERMISSIONS.PHARMACY_VIEW_ORDERS,
                  PERMISSIONS.PHARMACY_DISPENSE,
                  PERMISSIONS.CLINICAL_PRESCRIPTION_READ,
                ]}
              >
                <Pharmacy />
              </LayoutWrapper>
            }
          />
          <Route
            path="/add-patient"
            element={
              <LayoutWrapper
                permission={PERMISSIONS.PATIENTS_REGISTER}
              >
                <Patients />
              </LayoutWrapper>
            }
          />
          <Route
            path="/select-patient-assessment"
            element={
              <LayoutWrapper
                role={[1, 3, 5, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.CLINICAL_ASSESSMENT_READ,
                  PERMISSIONS.CLINICAL_ASSESSMENT_WRITE,
                ]}
              >
                <AssessmentPatientList />
              </LayoutWrapper>
            }
          />
          <Route
            path="/opd-assessment"
            element={
              <LayoutWrapper
                role={[1, 3, 5, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.CLINICAL_ASSESSMENT_READ,
                  PERMISSIONS.CLINICAL_ASSESSMENT_WRITE,
                ]}
              >
                <Assessment />
              </LayoutWrapper>
            }
          />
          <Route
            path="/doctor-opd"
            element={
              <LayoutWrapper permission={PERMISSIONS.OPD_VIEW_QUEUE}>
                <OPD />
              </LayoutWrapper>
            }
          />
          <Route
            path="/Patients"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 4, 5, 8, 9, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.OPD_VIEW_QUEUE,
                  PERMISSIONS.PATIENTS_READ,
                ]}
              >
                <OPD />
              </LayoutWrapper>
            }
          />
          <Route
            path="/doctor-assessment"
            element={
              <LayoutWrapper
                role={[1, 3, 5, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.CLINICAL_ASSESSMENT_READ,
                  PERMISSIONS.CLINICAL_ASSESSMENT_WRITE,
                ]}
              >
                <DoctorAssessment />
              </LayoutWrapper>
            }
          />
          <Route
            path="/OPDDetails"
            element={
              <LayoutWrapper
                anyPermissions={[
                  PERMISSIONS.OPD_VIEW_QUEUE,
                  PERMISSIONS.CLINICAL_PRESCRIPTION_READ,
                ]}
              >
                <OPDDetails />
              </LayoutWrapper>
            }
          />
          <Route
            path="/doctor-Diagnostics"
            element={
              <LayoutWrapper
                anyPermissions={[
                  PERMISSIONS.OPD_VIEW_QUEUE,
                  PERMISSIONS.PATIENTS_READ,
                ]}
              >
                <DoctorDiagnostics />
              </LayoutWrapper>
            }
          />
          <Route
            path="/select-patient-lab"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 6, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.LAB_READ,
                  PERMISSIONS.LAB_ORDER,
                  PERMISSIONS.LAB_ENTER_RESULTS,
                  PERMISSIONS.LAB_READ_RESULTS,
                ]}
              >
                <PatientSelection />
              </LayoutWrapper>
            }
          />
          <Route
            path="/create-lab-report"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 6, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.LAB_READ,
                  PERMISSIONS.LAB_ORDER,
                  PERMISSIONS.LAB_ENTER_RESULTS,
                  PERMISSIONS.LAB_READ_RESULTS,
                ]}
              >
                <CreateLabReports />
              </LayoutWrapper>
            }
          />
          <Route
            path="/view-create-lab-report"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 6, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.LAB_READ,
                  PERMISSIONS.LAB_ORDER,
                  PERMISSIONS.LAB_ENTER_RESULTS,
                  PERMISSIONS.LAB_READ_RESULTS,
                ]}
              >
                <ViewCreateLabRepor />
              </LayoutWrapper>
            }
          />
          <Route
            path="/consents"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 5, 7, 9, 10]}
                permission={PERMISSIONS.ABDM_CONSENT_READ}
              >
                <Consents />
              </LayoutWrapper>
            }
          />
          <Route
            path="/listing"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 5, 6, 7, 9, 10, 11]}
                permission={PERMISSIONS.PATIENTS_SEARCH}
              >
                <Listing />
              </LayoutWrapper>
            }
          />
          <Route
            path="/print-invoice"
            element={
              <LayoutWrapper
                role={[1, 2, 3, 4, 5, 8, 9, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.BILLING_READ_INVOICE,
                  PERMISSIONS.PATIENTS_REGISTER,
                  PERMISSIONS.PATIENTS_READ,
                ]}
              >
                <PrintInvoice />
              </LayoutWrapper>
            }
          />
          <Route
            path="/billing-print-invoice"
            element={
              <LayoutWrapper permission={PERMISSIONS.BILLING_READ_INVOICE}>
                <BillingPrintInvoice />
              </LayoutWrapper>
            }
          />
          <Route
            path="/patients-list"
            element={
              <LayoutWrapper permission={PERMISSIONS.PATIENTS_READ}>
                <PatientsLists />
              </LayoutWrapper>
            }
          />
          <Route
            path="/discharge-summary"
            element={
              <LayoutWrapper
                role={[1, 3, 5, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.CLINICAL_DISCHARGE_READ,
                  PERMISSIONS.CLINICAL_DISCHARGE_WRITE,
                ]}
              >
                <DischargeSummary />
              </LayoutWrapper>
            }
          />
          <Route
            path="/discharge-summary-form"
            element={
              <LayoutWrapper
                role={[1, 3, 5, 10, 11]}
                anyPermissions={[
                  PERMISSIONS.CLINICAL_DISCHARGE_READ,
                  PERMISSIONS.CLINICAL_DISCHARGE_WRITE,
                ]}
              >
                <DischargeSummaryForm />
              </LayoutWrapper>
            }
          />
          <Route
            path="/patient-detail/:id"
            element={
              <LayoutWrapper permission={PERMISSIONS.PATIENTS_READ}>
                <PatientDetailNew />
              </LayoutWrapper>
            }
          />
          <Route
            path="/visit-summary/:visitId"
            element={
              <LayoutWrapper permission={PERMISSIONS.PATIENTS_READ}>
                <VisitSummary />
              </LayoutWrapper>
            }
          />

          {/* M1 Public / ABDM Routes */}
          <Route path="/abha-home" element={<AbhaAbout />} />
          <Route path="/aadhar-abha-create" element={<AadharVerificationPage />} />
          <Route path="/abha-Card" element={<UserABHAprofile />} />
          <Route path="/my-profile" element={<UserProfileABDM />} />
          <Route path="/delete-deactivate-account" element={<DeleteDeactivateAccount />} />
          <Route path="/login-ABHA" element={<LoginABHAPage />} />
          <Route path="/forgoat-ABHA" element={<ForgotABHAPage />} />
          <Route path="/re-activate" element={<ReactivateABHA />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/products" element={<Products />} />
          <Route path="/getdemo" element={<GetDemo />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/profile" element={<UserABHAcard />} />
          <Route path="/findabha" element={<FindAbha />} />
          <Route path="/encrypt" element={<StringEncryption />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default WebRoutes;
